import { render, staticRenderFns } from "./GeneratorDetail.vue?vue&type=template&id=83fe038e&"
import script from "./GeneratorDetail.vue?vue&type=script&lang=js&"
export * from "./GeneratorDetail.vue?vue&type=script&lang=js&"
import style0 from "./GeneratorDetail.vue?vue&type=style&index=0&id=83fe038e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports